import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "col-md-12 container-fluid bg-white rounded shadow mt-3 p-3 text-start py-3" }
const _hoisted_3 = {
  key: 0,
  class: "text-start"
}
const _hoisted_4 = {
  key: 1,
  class: "text-start"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_6 = {
  class: "accordion",
  id: "accordionPanelsStayOpenExample"
}
const _hoisted_7 = { class: "accordion-item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", {
  class: "accordion-header",
  id: "panelsStayOpen-headingOne"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "accordion-button",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#panelsStayOpen-collapseOne",
    "aria-expanded": "true",
    "aria-controls": "panelsStayOpen-collapseOne"
  }, "ภาษาไทย")
], -1)
const _hoisted_9 = {
  class: "accordion-collapse collapse show",
  id: "panelsStayOpen-collapseOne",
  "aria-labelledby": "panelsStayOpen-headingOne"
}
const _hoisted_10 = { class: "accordion-body" }
const _hoisted_11 = { class: "row text-start" }
const _hoisted_12 = { class: "col-sm-12 col-md-12 mb-3 mt-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "ชื่อหมวดหมู่", -1)
const _hoisted_14 = { class: "col-sm-12 col-md-12 mb-3 mt-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "คำอธิบาย", -1)
const _hoisted_16 = { class: "accordion-item" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h2", {
  class: "accordion-header",
  id: "panelsStayOpen-headingTwo"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "accordion-button collapsed",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#panelsStayOpen-collapseTwo",
    "aria-expanded": "false",
    "aria-controls": "panelsStayOpen-collapseTwo"
  }, "ภาษาอังกฤษ")
], -1)
const _hoisted_18 = {
  class: "accordion-collapse collapse",
  id: "panelsStayOpen-collapseTwo",
  "aria-labelledby": "panelsStayOpen-headingTwo"
}
const _hoisted_19 = { class: "accordion-body" }
const _hoisted_20 = { class: "row text-start" }
const _hoisted_21 = { class: "col-sm-12 col-md-12 mb-3 mt-3" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "ชื่อหมวดหมู่ (ภาษาอังกฤษ)", -1)
const _hoisted_23 = { class: "col-sm-12 col-md-12 mb-3 mt-3" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "คำอธิบาย (ภาษาอังกฤษ)", -1)
const _hoisted_25 = { class: "accordion-item" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h2", {
  class: "accordion-header",
  id: "panelsStayOpen-headingThree"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "accordion-button collapsed",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#panelsStayOpen-collapseThree",
    "aria-expanded": "false",
    "aria-controls": "panelsStayOpen-collapseThree"
  }, "ภาษาจีน")
], -1)
const _hoisted_27 = {
  class: "accordion-collapse collapse",
  id: "panelsStayOpen-collapseThree",
  "aria-labelledby": "panelsStayOpen-headingThree"
}
const _hoisted_28 = { class: "accordion-body" }
const _hoisted_29 = { class: "row text-start" }
const _hoisted_30 = { class: "col-sm-12 col-md-12 mb-3 mt-3" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "ชื่อ (ภาษาจีน)", -1)
const _hoisted_32 = { class: "col-sm-12 col-md-12 mb-3 mt-3" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "คำอธิบาย (ภาษาจีน)", -1)
const _hoisted_34 = { class: "col-sm-12 col-md-12 mb-3 mt-3" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "รูปภาพ", -1)
const _hoisted_36 = { class: "col-sm-12" }
const _hoisted_37 = { class: "col-sm-12 col-md-12 mb-3" }
const _hoisted_38 = ["src"]
const _hoisted_39 = { class: "d-flex mb-5 justify-content-center mt-3" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "ms-5" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JMUpload = _resolveComponent("JMUpload")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (this.$route.params.id == undefined)
        ? (_openBlock(), _createElementBlock("h4", _hoisted_3, "เพิ่มหมวดหมู่"))
        : (_openBlock(), _createElementBlock("h4", _hoisted_4, "แก้ไขหมวดหมู่")),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.doc.nameTH) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.doc.nameTH]
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _withDirectives(_createElementVNode("textarea", {
                    class: "form-control",
                    style: {"height":"5em"},
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.doc.descriptionTH) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.doc.descriptionTH]
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    type: "text",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.doc.nameEN) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.doc.nameEN]
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _withDirectives(_createElementVNode("textarea", {
                    class: "form-control",
                    style: {"height":"5em"},
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.doc.descriptionEN) = $event))
                  }, "     ", 512), [
                    [_vModelText, _ctx.doc.descriptionEN]
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    type: "text",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.doc.nameCH) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.doc.nameCH]
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _withDirectives(_createElementVNode("textarea", {
                    class: "form-control",
                    style: {"height":"5em"},
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.doc.descriptionCH) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.doc.descriptionCH]
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _hoisted_35,
          _createElementVNode("div", _hoisted_36, [
            _createVNode(_component_JMUpload, {
              folder: "media",
              modelValue: _ctx.doc.image,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.doc.image) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("img", {
              src: _ctx.imageUrl(_ctx.doc.image),
              height: "200"
            }, null, 8, _hoisted_38)
          ])
        ]),
        _createElementVNode("div", _hoisted_39, [
          _createVNode(_component_router_link, {
            class: "btn btn-dark",
            to: `/portal/category`
          }, {
            default: _withCtx(() => [
              _createTextVNode("ยกเลิก")
            ]),
            _: 1
          }),
          _hoisted_40,
          _createElementVNode("a", {
            class: "btn btn-secondary bg-secondary",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)))
          }, "บันทึก")
        ])
      ])
    ])
  ]))
}